import { docReady } from './helpers';
import axios from 'axios';

/**
 * Only execute the code bellow once the doc has entered it's interactive state
 */
docReady(() => {
  /**
   * Fetches the sidebar navigation & handles the open/close toggle state
   */
  const togglers = document.querySelectorAll('[data-role=toggler]');
  const togglees = document.querySelectorAll('[data-role=togglee]');

  togglers.forEach((toggle) => {
    toggle?.addEventListener('click', () => {
      const toggleId = toggle.getAttribute('data-togglerid');
      Array.from(togglees)
        .filter((t) => t.getAttribute('data-togglerid') === toggleId)
        ?.forEach((i) =>
          i.setAttribute(
            'data-state',
            i.getAttribute('data-state') === 'passive' ? 'active' : 'passive'
          )
        );
      toggle.setAttribute(
        'data-state',
        toggle.getAttribute('data-state') === 'passive' ? 'active' : 'passive'
      );
    });
  });

  /**
   * Fetches tabs & handles the toggling of them
   */
  const toggleTabs = (t) => {
    const z = document
      .querySelector('.js--tabs-open[data-tab="' + t + '"]')
      ?.closest('.tabs');
    if (z) {
      z.querySelectorAll('.tabs__label, .tabs__item')?.forEach((el) =>
        el.setAttribute('data-state', 'passive')
      );
      z.querySelectorAll(
        '.tabs__label[data-tab=' + t + '], .tabs__item[data-tab=' + t + ']'
      )?.forEach((el) => el.setAttribute('data-state', 'active'));
    }
  };

  // Check whether a URI param is given that specifies which tab should be open
  const queryString = new URLSearchParams(window.location.search);
  if (queryString.has('tab')) toggleTabs(queryString.get('tab'));

  // Creates the click event handles on the tabs
  document.querySelectorAll('.js--tabs-open').forEach((el) =>
    el.addEventListener('click', (e) => {
      e.preventDefault();
      toggleTabs(el.getAttribute('data-tab'));
    })
  );

  if (typeof $.fn.accordion !== 'undefined' && $('#accordion').length > 0) {
    $('#accordion').accordion({
      active: 0,
      animate: 200,
      heightStyle: 'content',
    });
  }

  // Event delegation, since simplepopup isn't available on page load because it's transfered to a Vue contextMenu component
  $(document).on('click', '.simplepopup', function (event) {
    event.preventDefault();
    $('.remuaddpopup').addClass('is--active');
  });

  $('.rempopup--trigger').on('click', (event) => {
    event.preventDefault();
    $('.rempopup').addClass('is--active');
    $('.rempopup #commit-remove').attr(
      'href',
      $(event.currentTarget).data('link')
    );
  });

  $('body').on('click', '.showform1', function () {
    $(this).addClass('active');
    $('.showform2').removeClass('active');

    $('.form1').show();
    $('.form2').hide().removeClass('active');
  });

  $('body').on('click', '.showform2', function () {
    $('.showform1').removeClass('active');
    $(this).addClass('active');

    $('.form2').show();
    $('.form1').hide();
  });

  $('.rempopup--trigger--org').on('click', (event) => {
    event.preventDefault();
    $('.rempopupOrg').addClass('is--active');
    $('.rempopupOrg #commit-remove').attr(
      'href',
      $(event.currentTarget).data('link')
    );
  });

  $('body').on('click', '.seecontent', function (event) {
    $(this).parent().find('.invitationcontent').addClass('is--active');
  });

  $('body').on('change', '#Form_InvitationForm_Email', function () {
    $('#Form_InvitationForm_action_doProces')
      .addClass('disabled')
      .prop('disabled', true);

    if ($(this).val) {
      $(this).attr('required', 'required');
      $(this)
        .parent()
        .parent()
        .parent()
        .find('input')
        .attr('required', 'required');
    } else {
      $(this).removeAttr('required');
      $(this).parent().parent().parent().find('input').removeAttr('required');
    }

    if (
      $(this).parent().parent().parent().find('div.text-info').text() != '' &&
      $(this).parent().parent().parent().find('div.text-info').text() !=
        'Organisatie niet gevonden'
    ) {
      $('#Form_InvitationForm_action_doProces')
        .removeClass('disabled')
        .prop('disabled', false);
    }
  });

  $('body').on('paste', '#Form_InvitationForm_KvKNumber', function () {
    $('#Form_InvitationForm_action_doProces')
      .addClass('disabled')
      .prop('disabled', true);
    var test = this;
    setTimeout(function () {
      if (
        $('#Form_InvitationForm_KvKNumber')
          .parent()
          .siblings('div.text-info')
          .text() != '' &&
        $('#Form_InvitationForm_KvKNumber')
          .parent()
          .siblings('div.text-info')
          .text() != 'Organisatie niet gevonden'
      ) {
        $('#Form_InvitationForm_action_doProces')
          .removeClass('disabled')
          .prop('disabled', false);
      }
    }, 2000);
  });

  $('body').on('change', '#Form_InvitationForm_KvKNumber', function () {
    $('#Form_InvitationForm_action_doProces')
      .addClass('disabled')
      .prop('disabled', true);

    if ($(this).val) {
      $(this).attr('required', 'required');
      $(this)
        .parent()
        .parent()
        .parent()
        .find('input')
        .attr('required', 'required');
    } else {
      $(this).removeAttr('required');
      $(this).parent().parent().parent().find('input').removeAttr('required');
    }

    if (
      $(this).parent().siblings('div.text-info').text() != '' &&
      $(this).parent().siblings('div.text-info').text() !=
        'Organisatie niet gevonden'
    ) {
      $('#Form_InvitationForm_action_doProces')
        .removeClass('disabled')
        .prop('disabled', false);
    }
  });

  if ($('#OrganizationUserForm_edit_GroupID').length > 0) {
    var value = $(
      '#OrganizationUserForm_toevoegen_GroupID :selected, #OrganizationUserForm_edit_GroupID :selected'
    ).text(); // English
    if (value === 'Admin (Organisatie) ') {
      $('.OrganisationStep2').hide();
      $('.OrganisationStep1').show();
    }
  }

  $('body').on(
    'change',
    '#OrganizationUserForm_toevoegen_GroupID,#OrganizationUserForm_edit_GroupID',
    function (event) {
      var value = $(
        '#OrganizationUserForm_toevoegen_GroupID :selected, #OrganizationUserForm_edit_GroupID :selected'
      ).text(); // English
      if (value === 'Admin (Organisatie) ') {
        $('.OrganisationStep2').hide();
        $('.OrganisationStep1').show();
      } else {
        $('.OrganisationStep1').hide();
        $('.OrganisationStep2').show();
      }
    }
  );

  // $('body').on('change', '#OrganizationUserForm_toevoegen_GroupID, #OrganizationUserForm_edit_GroupID', function (event) {
  //   $('.changebyselect option').removeAttr('selected');
  //   if ($(this).val() === '22') {
  //     $('.changebyselect option[value="25"]').attr('selected', true);
  //     $(".changebyselect").trigger("chosen:updated");
  //   }
  //   else {
  //     $('.changebyselect option[value="5"]').attr('selected', true);
  //     $(".changebyselect").trigger("chosen:updated");
  //   }
  // });

  $('body').on('change', '.changebyselect', function (event) {
    $(this).find('option').removeAttr('selected');
  });

  $('body').on(
    'click',
    '.Form_addMultipleLenders_action_doReturnToPage',
    function (event) {
      event.preventDefault();
      $('.customaddpop').removeClass('is--active');
    }
  );

  $('body').on(
    'click',
    '#Form_AddUsersAfterUnlinkForm_action_doReturnToPage',
    function (event) {
      event.preventDefault();
      $('.rempopupUnlink').removeClass('is--active');
      $('.AddUsersAfterUnlink').html('');
    }
  );

  if ($('.activetoggle').length > 0) {
    $('#ui-id-5').trigger('click');
  }

  $('body').on('click', '.deletepopupinpopup--trigger', function (event) {
    event.preventDefault();
    $('.deletepopupinpopup').addClass('is--active');
    $('.deletepopupinpopup #commit-remove').attr(
      'href',
      $(event.currentTarget).data('link')
    );
  });

  $('body').on('click', '.deletepopupinpopup-js-modal-close', function (event) {
    event.preventDefault();
    $('.deletepopupinpopup').removeClass('is--active');
  });

  $('body').on('click', '.respondtoinvites', function (event) {
    event.preventDefault();
    $('.customrespondtoinvitation').addClass('is--active');
  });

  $('body').on('click', '.DeactivateAfterCLick', function (event) {
    event.preventDefault();
    event.stopPropagation();
    $(this).removeClass('DeactivateAfterCLick');
    var link = $(this).attr('href');
    $(this).removeAttr('href').css('opacity', '0.5');
    window.location.href = link;
  });

  $('body').on('click', '#commit-remove', function (event) {
    event.preventDefault();
    event.stopPropagation();
    var link = $(this).attr('href');
    $(this).removeAttr('href').css('opacity', '0.5');
    $(this).addClass('DeactivateAfterCLick');
    $(this).off('click').attr('href', 'javascript: void(0);');
    if (typeof link !== 'undefined') {
      window.location.href = link;
    }
  });

  function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  // redo in vue oneday
  $('body').on('change', '#RegistrationForm_Email', function (event) {
    var email = $(this).val();
    if (validateEmail(email) == false) {
      $('#js--email-validation-error').show().text('Email is niet correct.');
      $('#RegistrationForm_action_registreren_inlener_registerFormAction')
        .addClass('disabled')
        .prop('disabled', true);
    } else {
      $('#js--email-validation-error').show().text('');
      $('#RegistrationForm_action_registreren_inlener_registerFormAction')
        .removeClass('disabled')
        .prop('disabled', false);

      const baseHref = document.getElementsByTagName('base')[0].href;
      $.ajax({
        type: 'POST',
        url: `${baseHref}registreren/checkEmail/`,
        data: {
          email,
        },
        success: function (data) {
          const result = data === 'true';

          if (result) {
            $('#RegistrationForm_error').show().text('sadres is al in gebruik');
            $('#RegistrationForm_action_registreren_inlener_registerFormAction')
              .addClass('disabled')
              .prop('disabled', true);
          } else {
            $('#RegistrationForm_error').hide().text('');
            $('#RegistrationForm_action_registreren_inlener_registerFormAction')
              .removeClass('disabled')
              .prop('disabled', false);
          }
        },
      });
    }
  });

  // check and prefill // organisation
  $('body').on(
    'change',
    '#OrganizationUserForm_toevoegen_Email',
    function (event) {
      var email = $(this).val();
      const baseHref = document.getElementsByTagName('base')[0].href;
      $.ajax({
        type: 'POST',
        url: `${baseHref}registreren/checkEmail/`,
        data: {
          email,
        },
        success: function (data) {
          const result = data === 'true';
          const field = $('#OrganizationUserForm_toevoegen_Email_Holder');
          const notice_field = $('.customerror');
          $('#OrganizationUserForm_toevoegen_action_addAction').prop(
            'disabled',
            result
          );

          if (result) {
            if (notice_field.length === 0) {
              field.append(
                '<span style="color:red" class="customerror">Er bestaat al een gebruiker met dit e-mailadres, neem contact op met <a href="mailto:support@inlenersbeloning.com">inlenersbeloning.com</a> indien u deze gebruiker wilt toevoegen aan uw organisatie overzicht.</span>'
              );
            }
          } else {
            notice_field.remove();
          }
        },
      });
    }
  );

  $('.popupwithlinkings').click(function (event) {
    event.preventDefault();
    $(this).parent().parent().find('.customaddpop').addClass('is--active');
  });

  // check and prefill // bv
  $('body').on('change', '#UserForm_toevoegen_Email', function (event) {
    var email = $(this).val();
    const baseHref = document.getElementsByTagName('base')[0].href;
    $.ajax({
      type: 'POST',
      url: `${baseHref}registreren/checkEmail/`,
      data: {
        email,
      },
      success: function (data) {
        const result = data === 'true';
        const selectors =
          '#UserForm_toevoegen_FirstName, #UserForm_toevoegen_Surname, #UserForm_toevoegen_PhoneNumber,#UserForm_toevoegen_FunctionTitle, #UserForm_toevoegen_Establishment';
        const field = $('#UserForm_toevoegen_Email_Holder');
        const notice_field = $('.customerror');

        const fields_to_change = $(selectors);

        $('#UserForm_toevoegen_Salutation').prop('required', !result);
        fields_to_change.prop('required', !result);
        fields_to_change.prop('disabled', result);

        if (result) {
          $('#UserForm_toevoegen_Salutation').attr('value', 'Dhr.');

          fields_to_change.val('-');
          fields_to_change.attr('value', '-');

          if (notice_field.length === 0) {
            field.append(
              '<span style="color:green" class="customerror">Er bestaat al een gebruiker met dit e-mailadres, Op basis hiervan zal deze gebruiker toegevoegd worden. U hoeft geen verdere gegevens in te vullen.</span>'
            );
          }
        } else {
          notice_field.remove();
          $('#UserForm_toevoegen_Salutation').attr('value', null);
        }
      },
    });
  });

  $(document).on('click', '.cleanremuna', function (event) {
    event.preventDefault();
    $('.emptypopup').addClass('is--active');
  });
});
